import React from 'react';

const FinalCTASection = ({ aoClicarBotao }) => {
  return (
    <section className="bg-[#0e1a2b] py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Pronto Para Construir Sua{' '}
            <span className="text-elion-gold">Sociedade Imobiliária?</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-12 opacity-90">
            Chegou o momento de assumir o protagonismo e conquistar o espaço que
            você merece.
          </p>
          <div className="space-y-6">
            <button
              onClick={aoClicarBotao}
              className="bg-elion-gold text-elion-navy text-lg px-12 py-6 rounded-lg font-bold hover:bg-yellow-400 hover:text-elion-navy transition-all duration-300 transform hover:scale-105 shadow-2xl"
            >
              Liberar Meu Acesso
            </button>
            <p className="text-gray-300 text-sm opacity-75">
              Garanta 7 dias de acesso gratuito e descubra como a Elion pode
              transformar sua carreira imobiliária.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
